import React from "react";
import useUserStore from "../../store/useUserStore.ts";
import {Avatar, Flex, Tooltip} from "@chakra-ui/react";
import {usePreferencesModal} from "../../hooks/usePreferencesModal.tsx";

interface UserProfileProps {
  minimizedState: boolean;
}

const UserProfile: React.FC<UserProfileProps> = ({minimizedState}) => {
  const {user} = useUserStore()
  const showPreferencesModal: () => void = usePreferencesModal()

  return (
    <div
      className={` ${
        !minimizedState
          ? "shadow-[0_1.25rem_1.5rem_0_rgba(0,0,0,0.5)]"
          : ""
      }`}
      data-testid="user-profile"
    >
      <div className={`${!minimizedState && "p-2.5 bg-n-600 rounded-xl"}`}>
        <div
          className={`flex items-center ${
            minimizedState ? "justify-center" : "px-2.5 py-2.5 pb-4.5"
          }`}
        >
          <div className="relative w-10 h-10">
            <Avatar
              size="md"
              name={`${user?.firstName} ${user?.lastName}`}
              src={user?.avatarSasLink}
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              border="1px solid transparent"
            />
            <div
              className="absolute -right-0.75 -bottom-0.75 w-4.5 h-4.5 bg-success-500 rounded-full border-4 border-n-600"></div>
          </div>
          {!minimizedState && (
            <>
              <div className="ml-4 mr-4">
                <div className="base2 font-semibold text-n-100">
                  {user?.firstName} {user?.lastName}
                </div>
                {/*{user?.email && user.email.length > 18 ? (*/}
                {/*  <Tooltip label={user.email} aria-label="Email tooltip">*/}
                {/*    <div className="caption1 font-semibold text-n-300/50">*/}
                {/*      {user.email.slice(0, 18)}...*/}
                {/*    </div>*/}
                {/*  </Tooltip>*/}
                {/*) : (*/}
                {/*  <div className="caption1 font-semibold text-n-300/50">*/}
                {/*    {user?.email}*/}
                {/*  </div>*/}
                {/*)}*/}
                <div className="caption1 font-semibold text-n-300/50">
                  {user?.email}
                </div>
              </div>
              {/*<div className="shrnik-0 ml-auto self-start px-3 bg-success-500 rounded-lg caption1 font-bold text-n-700">*/}
              {/*  Role*/}
              {/*</div>*/}
            </>
          )}
        </div>
        {/*{!minimizedState && (*/}
        {/*  <Flex*/}
        {/*    className="btn-stroke-dark w-full block text-center cursor-pointer"*/}
        {/*    onClick={showPreferencesModal}*/}
        {/*  >*/}
        {/*    Preferences*/}
        {/*  </Flex>*/}
        {/*)}*/}
      </div>
    </div>
  );
};

export default UserProfile;